/* =========================================================
   SIIN – tema för SåiniNordeN
   Header, megameny, mobilmeny, sök, varukorg, filter, produktsida
   ========================================================= */
(function () {
  'use strict';
  var R = (window.SIIN && window.SIIN.routes) || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
  var debounce = function (fn, ms) { var t; return function () { var a = arguments, self = this; clearTimeout(t); t = setTimeout(function () { fn.apply(self, a); }, ms); }; };

  /* ---------- Paneler (meny, sök, varukorg, filter) ---------- */
  var openId = null, lastFocus = null;
  function ov() { return $('.ov'); }
  function open(id) {
    var el = document.getElementById(id); if (!el) return;
    if (openId && openId !== id) close(true);
    lastFocus = document.activeElement; openId = id;
    el.classList.add('on'); el.setAttribute('aria-hidden', 'false');
    var o = ov(); if (o) { o.hidden = false; requestAnimationFrame(function () { o.classList.add('on'); }); }
    document.body.classList.add('lock');
    if (id === 'mm') $$('.mm-open').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () {
      var f = id === 'srch' ? $('#srch-q') : el.querySelector('.x,[data-close-filters]');
      if (f) f.focus({ preventScroll: true });
    }, 80);
  }
  function close(keep) {
    if (!openId) return;
    var el = document.getElementById(openId);
    if (el) { el.classList.remove('on'); el.setAttribute('aria-hidden', 'true'); }
    var o = ov(); if (o) o.classList.remove('on');
    document.body.classList.remove('lock');
    if (openId === 'mm') $$('.mm-open').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openId = null;
    if (!keep && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.SIIN.open = open; window.SIIN.close = close;

  // Håll fokus inne i öppen panel
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMega(); closeFd(); closeModal(); close(); return; }
    if (e.key !== 'Tab' || !openId) return;
    var el = document.getElementById(openId); if (!el) return;
    var f = $$('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', el).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- Header ---------- */
  function initHeader() {
    // Flytta paneler till body så att de hamnar ovanför overlayn
    ['mm', 'srch'].forEach(function (id) { var el = document.getElementById(id); if (el && el.parentNode !== document.body) document.body.appendChild(el); });
    var hdr = $('#hdr');
    if (hdr) {
      var tick = false;
      window.addEventListener('scroll', function () {
        if (tick) return; tick = true;
        requestAnimationFrame(function () { hdr.classList.toggle('min', window.scrollY > 140); tick = false; });
      }, { passive: true });
    }
    // Megameny
    var t;
    $$('.nav li.has-mega').forEach(function (li) {
      var a = li.firstElementChild;
      li.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { setMega(li); }, $('.nav li.open') ? 0 : 120); });
      li.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { setMega(null); }, 160); });
      a.addEventListener('click', function (e) { if (!li.classList.contains('open')) { e.preventDefault(); setMega(li); } });
      a.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { e.preventDefault(); setMega(li); var x = li.querySelector('.mega a'); if (x) x.focus(); } });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) setMega(null); });
    });
    $$('.nav>ul>li:not(.has-mega)').forEach(function (li) { li.addEventListener('mouseenter', function () { clearTimeout(t); setMega(null); }); });
    // Mobilmeny
    $$('.mm-i>button').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = b.parentNode, o = !p.classList.contains('op');
        $$('.mm-i.op').forEach(function (x) { if (x !== p) { x.classList.remove('op'); x.firstElementChild.setAttribute('aria-expanded', 'false'); } });
        p.classList.toggle('op', o); b.setAttribute('aria-expanded', o);
        if (o) setTimeout(function () { b.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 320);
      });
    });
    // Footer-kolumner ihopfällda på mobil
    if (window.matchMedia('(max-width:700px)').matches) $$('.foot-col details').forEach(function (d) { d.removeAttribute('open'); });
  }
  function setMega(li) {
    $$('.nav li.open').forEach(function (x) { if (x !== li) { x.classList.remove('open'); x.firstElementChild.setAttribute('aria-expanded', 'false'); } });
    if (li) { li.classList.add('open'); li.firstElementChild.setAttribute('aria-expanded', 'true'); }
    var d = $('.hdr-dim'); if (d) d.classList.toggle('on', !!li);
  }
  function closeMega() { setMega(null); }

  /* ---------- Sök ---------- */
  var searchCtrl;
  function initSearch() {
    var q = $('#srch-q'), box = $('.srch-main'); if (!q || !box) return;
    var initial = box.innerHTML;
    var run = debounce(function () {
      var v = q.value.trim();
      if (!v) { box.innerHTML = initial; return; }
      if (searchCtrl) searchCtrl.abort();
      searchCtrl = 'AbortController' in window ? new AbortController() : null;
      var url = R.predictive + '?q=' + encodeURIComponent(v) + '&section_id=predictive-search&resources[type]=product,collection,page,query&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,vendor,product_type,tag,variants.title';
      fetch(url, searchCtrl ? { signal: searchCtrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
        var s = parse(html).querySelector('#shopify-section-predictive-search');
        box.innerHTML = s ? s.innerHTML : '';
      }).catch(function () { });
    }, 220);
    q.addEventListener('input', run);
    document.addEventListener('click', function (e) {
      var c = e.target.closest('.srch [data-q]'); if (!c) return;
      q.value = c.dataset.q; run(); q.focus();
    });
  }

  /* ---------- Varukorg ---------- */
  function sectionIds() {
    var ids = ['cart-drawer'];
    var page = $('[data-cart-page]'); if (page) ids.push(page.dataset.section);
    return ids;
  }
  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var doc = parse(html);
      if (id === 'cart-drawer') {
        var fresh = doc.querySelector('#drw'), cur = $('#drw');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      } else {
        var wrap = document.getElementById('shopify-section-' + id), inner = doc.querySelector('#shopify-section-' + id);
        if (wrap && inner) wrap.innerHTML = inner.innerHTML;
      }
    });
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = n > 0 ? n : ''; });
  }
  function refreshCount() {
    return fetch(R.root.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); return c; });
  }
  function addToCart(items, btn, errEl) {
    if (btn) btn.classList.add('is-loading');
    if (errEl) errEl.hidden = true;
    return fetch(R.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionIds().join(','), sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (btn) btn.classList.remove('is-loading');
      if (!res.ok) { var msg = res.j.description || res.j.message || 'Något gick fel. Försök igen.'; if (errEl) { errEl.textContent = msg; errEl.hidden = false; } else alert(msg); return; }
      if (window.SIIN.cartType === 'page') { location.href = R.cart; return; }
      renderSections(res.j.sections);
      refreshCount();
      open('drw');
    }).catch(function () { if (btn) btn.classList.remove('is-loading'); location.href = R.cart; });
  }
  function changeLine(key, qty) {
    var d = $('#drw'); if (d) d.style.opacity = '.6';
    var page = $('[data-cart-page]'); if (page) page.style.opacity = '.6';
    return fetch(R.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: sectionIds().join(','), sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (c) {
      renderSections(c.sections); updateCount(c.item_count);
      if (d) d.style.opacity = '';
      var p2 = $('[data-cart-page]'); if (p2) p2.style.opacity = '';
    }).catch(function () { location.reload(); });
  }

  /* ---------- Produktsida ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    var P = JSON.parse(jsonEl.textContent);
    P.options = P.options.map(function (o) { return String(o).replace(/^välj\s+/i, ''); });
    var form = $('[data-product-form]', root), idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-btn]', root), errEl = $('[data-form-error]', root);
    var fieldsets = $$('fieldset[data-opt]', root);
    fieldsets.forEach(function (fs) { var ins = fs.querySelectorAll('input'); if (ins.length === 1) ins[0].checked = true; });
    var sizeIdx = -1;
    fieldsets.forEach(function (fs, i) { if (!fs.hidden && fs.querySelector('.sizes:not(.opt-txt)')) sizeIdx = i; });
    var needChoice = false;
    // Kräv att kunden väljer storlek om ingen variant är vald i länken
    if (!P.selected && sizeIdx > -1 && fieldsets[sizeIdx].querySelectorAll('input').length > 1) {
      needChoice = true;
      $$('input', fieldsets[sizeIdx]).forEach(function (i) { i.checked = false; });
    }
    function selected() { return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function find(vals) { return P.variants.filter(function (v) { return v.options.every(function (o, i) { return vals[i] === o; }); })[0]; }
    function update(push) {
      var vals = selected();
      fieldsets.forEach(function (fs, i) { var l = fs.querySelector('[data-opt-label]'); if (l) l.textContent = vals[i] || ('Välj ' + P.options[i].toLowerCase()); });
      // Markera slutsålda värden givet övriga val
      fieldsets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (inp) {
          var test = vals.slice(); test[i] = inp.value;
          var ok = P.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return test[k] === null || test[k] === o || k === i && o === inp.value; }); });
          var lab = inp.closest('label'); if (lab) lab.classList.toggle('so', !ok);
        });
      });
      var v = vals.indexOf(null) === -1 ? find(vals) : null;
      var stickyV = $('[data-sticky-variant]', root);
      if (!v) {
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = vals.indexOf(null) > -1 ? 'Välj ' + P.options[vals.indexOf(null)].toLowerCase() : 'Inte tillgänglig'; addBtn.dataset.need = '1'; }
        if (stickyV) stickyV.textContent = 'Välj ' + P.options[P.options.length - 1].toLowerCase();
        var st0 = $('[data-stock-text]', root); if (st0) st0.textContent = P.variants.some(function (x) { return x.available; }) ? 'I lager, ' + st0.dataset.tpl : 'Slutsåld';
        return;
      }
      idInput.value = v.id;
      if (addBtn) { delete addBtn.dataset.need; addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Lägg i varukorgen' : 'Slutsåld'; }
      var pr = $('[data-price]', root);
      if (pr) pr.innerHTML = '<span class="price">' + (v.compare ? '<span class="now">' + v.price + '</span><span class="vh">Ordinarie pris</span><s>' + v.compare + '</s>' : v.price) + '</span>';
      var sp = $('[data-sticky-price]', root); if (sp) sp.textContent = v.price;
      if (stickyV) stickyV.textContent = v.title;
      var st = $('[data-stock-text]', root);
      if (st) { var tail = st.dataset.tpl, low = +st.dataset.low || 0; st.textContent = !v.available ? 'Slutsåld' : (v.qty !== null && v.qty > 0 && v.qty <= low ? 'Bara ' + v.qty + ' kvar – ' + tail : 'I lager, ' + tail); }
      if (push && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
      if (push && v.media) { var s = $('[data-media-id="' + v.media + '"]', root); var tr = $('.gal-t', root); if (s && tr) tr.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }
      if (errEl) errEl.hidden = true;
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', function () { needChoice = false; update(true); }); });
    update(false);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn && addBtn.dataset.need) { if (errEl) { errEl.textContent = 'Välj ' + P.options[Math.max(0, sizeIdx)].toLowerCase() + ' först.'; errEl.hidden = false; } var fs = fieldsets[sizeIdx]; if (fs) fs.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      var q = form.querySelector('[name=quantity]');
      addToCart([{ id: +idInput.value, quantity: q ? Math.max(1, +q.value || 1) : 1 }], addBtn, errEl);
    });
    // Antal
    $$('[data-step]', root).forEach(function (b) { b.addEventListener('click', function () { var i = b.parentNode.querySelector('input'); i.value = Math.max(1, (+i.value || 1) + (+b.dataset.step)); }); });
    // Sticky köpknapp
    var bar = $('[data-sticky]', root);
    if (bar && addBtn) {
      var io = new IntersectionObserver(function (en) { var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; bar.classList.toggle('show', show); bar.setAttribute('aria-hidden', !show); $('[data-sticky-add]', bar).tabIndex = show ? 0 : -1; });
      io.observe(addBtn);
      $('[data-sticky-add]', bar).addEventListener('click', function () { if (addBtn.dataset.need) { fieldsets[sizeIdx].scrollIntoView({ block: 'center', behavior: 'smooth' }); if (errEl) { errEl.textContent = 'Välj ' + P.options[sizeIdx].toLowerCase() + ' först.'; errEl.hidden = false; } return; } form.requestSubmit ? form.requestSubmit() : addBtn.click(); });
    }
    // Galleri
    var tr = $('.gal-t', root); if (tr) {
      var n = tr.children.length, pos = $('.gal-pos', root), th = $$('[data-thumb]', root);
      var cur = function () { return Math.round(tr.scrollLeft / tr.clientWidth); };
      var go = function (i) { i = (i + n) % n; tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); };
      $$('[data-gal]', root).forEach(function (b) { b.addEventListener('click', function () { go(cur() + (+b.dataset.gal)); }); });
      th.forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.thumb); }); });
      tr.addEventListener('scroll', debounce(function () { var i = cur(); if (pos) pos.textContent = (i + 1) + ' / ' + n; th.forEach(function (b, j) { b.setAttribute('aria-current', j === i); }); }, 60), { passive: true });
      tr.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(cur() + 1); if (e.key === 'ArrowLeft') go(cur() - 1); });
    }
  }

  /* ---------- Bildbläddring i produktkort ---------- */
  /* Extra bilder i korten laddas först när kortet används, så att sidan laddar snabbare */
  function carLoad(w) {
    if (!w || w._loaded) return; w._loaded = true;
    w.querySelectorAll('img[data-src]').forEach(function (i) {
      if (i.dataset.srcset) { i.srcset = i.dataset.srcset; i.removeAttribute('data-srcset'); }
      i.src = i.dataset.src; i.removeAttribute('data-src');
    });
  }
  ['pointerover', 'touchstart', 'focusin'].forEach(function (n) {
    document.addEventListener(n, function (e) {
      var t = e.target; if (t && t.closest) carLoad(t.closest('[data-car]'));
    }, { passive: true });
  });
  function cardGo(btn) {
    var w = btn.closest('[data-car]'), t = w && w.querySelector('.car-t'); if (!t) return;
    var n = t.children.length, i = Math.round(t.scrollLeft / t.clientWidth) + (btn.classList.contains('r') ? 1 : -1);
    i = (i + n) % n; t.scrollTo({ left: i * t.clientWidth, behavior: 'smooth' });
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target; if (!t.classList || !t.classList.contains('car-t')) return;
    carLoad(t.closest('[data-car]'));
    clearTimeout(t._u); t._u = setTimeout(function () {
      var i = Math.round(t.scrollLeft / t.clientWidth), d = t.closest('[data-car]').querySelectorAll('.car-d i');
      for (var k = 0; k < d.length; k++) d[k].className = k === i ? 'on' : '';
    }, 50);
  }, true);

  /* ---------- Flikar och sliders ---------- */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (s) {
      var all = $('.js-tab-all', s);
      $$('[data-tab]', s).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-tab]', s).forEach(function (x) { x.setAttribute('aria-selected', x === b); });
          $$('[data-panel]', s).forEach(function (p) { p.hidden = p.dataset.panel !== b.dataset.tab; });
          if (all && b.dataset.href) { all.href = b.dataset.href; all.textContent = b.dataset.label; }
        });
      });
    });
    $$('[data-slider]', root).forEach(function (s) {
      var t = $('.slider-t', s), prog = $('.sl-prog i', s), bs = $$('[data-sl]', s); if (!t) return;
      var upd = function () { var max = t.scrollWidth - t.clientWidth, w = t.scrollWidth ? t.clientWidth / t.scrollWidth * 100 : 100; if (prog) { prog.style.width = w + '%'; prog.style.left = (max > 0 ? t.scrollLeft / max * (100 - w) : 0) + '%'; } if (bs.length) { bs[0].disabled = t.scrollLeft < 4; bs[1].disabled = t.scrollLeft > max - 4; } };
      bs.forEach(function (b) { b.addEventListener('click', function () { var c = t.firstElementChild ? t.firstElementChild.getBoundingClientRect().width + 24 : t.clientWidth; t.scrollBy({ left: +b.dataset.sl * c * 2, behavior: 'smooth' }); }); });
      t.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
  }

  /* ---------- Filter och sortering ---------- */
  function closeFd(except) { $$('.fbar details.fd[open]').forEach(function (d) { if (d !== except && !d.closest('.fdrw.on')) d.removeAttribute('open'); }); }
  function initFacets() {
    var sec = $('[data-facets]'); if (!sec) return;
    var id = sec.dataset.section;
    function load(url, push) {
      var wrap = document.getElementById('shopify-section-' + id), grid = $('.c-grid', wrap);
      var openFds = $$('details.fd[open]', wrap).map(function (d) { return d.dataset.fd; });
      var drawer = $('.fdrw.on', wrap), scroll = drawer ? $('.fdrw-b', drawer).scrollTop : 0;
      if (grid) grid.classList.add('loading');
      var u = new URL(url, location.origin); u.searchParams.set('section_id', id);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var inner = parse(html).querySelector('#shopify-section-' + id); if (!inner) { location.href = url; return; }
        wrap.innerHTML = inner.innerHTML; applyView(getView());
        if (push !== false) history.pushState({ facets: 1 }, '', url);
        if (drawer) { var nd = $('.fdrw', wrap); nd.classList.add('on'); nd.setAttribute('aria-hidden', 'false'); $('.fdrw-b', nd).scrollTop = scroll; }
        openFds.forEach(function (k) { var d = wrap.querySelector('details.fd[data-fd="' + CSS.escape(k) + '"]'); if (d && (drawer || window.innerWidth > 700)) d.setAttribute('open', ''); });
        if (!drawer) { var top = wrap.getBoundingClientRect().top + window.scrollY - 140; if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' }); }
      }).catch(function () { location.href = url; });
    }
    function formUrl(form) {
      var fd = new FormData(form), p = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
      var s = $('[data-sort]'); if (s) p.set('sort_by', s.value);
      return (($('[data-facets]') || sec).dataset.url) + '?' + p.toString();
    }
    document.addEventListener('change', function (e) {
      var f = e.target.closest('[data-facet-form]');
      if (f) { if (e.target.type === 'number') return; load(formUrl(f)); return; }
      if (e.target.matches('[data-sort]')) { var form = $('[data-facet-form]'); if (form) load(formUrl(form)); else { var u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); load(u.toString()); } }
    });
    document.addEventListener('input', debounce(function (e) { if (e.target.type === 'number' && e.target.closest('[data-facet-form]')) load(formUrl(e.target.closest('[data-facet-form]'))); }, 700));
    document.addEventListener('submit', function (e) { var f = e.target.closest('[data-facet-form]'); if (!f) return; e.preventDefault(); closeFd(); load(formUrl(f)); });
    /* Underkategorier: byt sida utan omladdning, så man stannar där man är */
    function swapPage(url, push) {
      var nav = $('.subnav-t'), x = nav ? nav.scrollLeft : 0, y = window.scrollY;
      var g = $('.c-grid'); if (g) g.classList.add('loading');
      fetch(url).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (html) {
        var doc = parse(html);
        var olds = $$('[id^="shopify-section-template--"]'), news = $$('[id^="shopify-section-template--"]', doc);
        if (!news.length || news.length !== olds.length || news.some(function (n, i) { return n.id !== olds[i].id; })) { location.href = url; return; }
        olds.forEach(function (o, i) { o.innerHTML = news[i].innerHTML; });
        document.title = doc.title;
        if (push !== false) history.pushState({ subnav: 1 }, '', url);
        applyView(getView());
        window.scrollTo(0, y);
        var nn = $('.subnav-t'); if (nn) nn.scrollLeft = x;
      }).catch(function () { location.href = url; });
    }
    document.addEventListener('click', function (e) {
      var sl = e.target.closest('.subnav a.chip');
      if (sl && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) { e.preventDefault(); if (!sl.classList.contains('on')) swapPage(sl.href); return; }
      var a = e.target.closest('[data-facet-link]'); if (a) { e.preventDefault(); load(a.href); return; }
      if (e.target.closest('[data-open-filters]')) { var d = $('.fdrw'); if (d) { d.id = d.id || 'fdrw'; open(d.id); } return; }
      if (e.target.closest('[data-close-filters]')) { close(); return; }
      var sum = e.target.closest('.fbar summary.fbtn');
      if (sum && window.innerWidth > 700) closeFd(sum.parentNode);
      if (!e.target.closest('.fd')) closeFd();
    });
    window.addEventListener('popstate', function () {
      var u = new URL(location.href);
      if ($('.subnav') && u.pathname !== new URL(($('[data-facets]') || sec).dataset.url, location.origin).pathname) swapPage(location.href, false);
      else load(location.href, false);
    });
  }


  /* ---------- Bildstorlek och Visa fler i kollektioner ---------- */
  function getView() { try { return localStorage.getItem('siin-view'); } catch (e) { return null; } }
  function applyView(v) {
    if (!v) return;
    $$('[data-grid]').forEach(function (g) { g.classList.toggle('v-lg', v === 'lg'); });
    $$('[data-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.view === v); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-view]');
    if (b) { applyView(b.dataset.view); try { localStorage.setItem('siin-view', b.dataset.view); } catch (err) { } return; }
    var m = e.target.closest('[data-load-more]'); if (!m) return;
    e.preventDefault(); if (m.classList.contains('is-loading')) return;
    var sec = m.closest('[data-facets]'), id = sec && sec.dataset.section; if (!id) { location.href = m.href; return; }
    m.classList.add('is-loading'); m.textContent = 'Laddar …';
    var u = new URL(m.href, location.origin); u.searchParams.set('section_id', id);
    fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
      var doc = parse(html), grid = $('[data-grid]', sec), ng = doc.querySelector('[data-grid]'), more = $('[data-more]', sec), nm = doc.querySelector('[data-more]');
      if (!grid || !ng) { location.href = m.href; return; }
      var first = ng.firstElementChild;
      while (ng.firstElementChild) grid.appendChild(ng.firstElementChild);
      if (more && nm) more.outerHTML = nm.outerHTML;
      var a = first && first.querySelector('.card-t a'); if (a) a.focus({ preventScroll: true });
    }).catch(function () { location.href = m.href; });
  });

  /* ---------- Modal (storleksguide) ---------- */
  var modalOpen = null;
  function closeModal() { if (!modalOpen) return; modalOpen.hidden = true; document.body.classList.remove('lock'); var b = modalOpen._from; modalOpen = null; if (b) b.focus(); }

  /* ---------- Rekommendationer ---------- */
  function initRecs() {
    $$('[data-recs]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var s = parse(html).querySelector('[data-recs]'); if (s && s.innerHTML.trim()) el.innerHTML = s.innerHTML; else el.remove();
      }).catch(function () { });
    });
  }

  /* ---------- Klick ---------- */
  document.addEventListener('click', function (e) {
    var x = e.target;
    if (x.closest('.mm-open')) { open('mm'); return; }
    if (x.closest('.js-search')) { e.preventDefault(); open('srch'); return; }
    if (x.closest('.js-cart') && window.SIIN.cartType !== 'page' && !$('[data-cart-page]')) { e.preventDefault(); open('drw'); return; }
    var ca = x.closest('.car-a'); if (ca) { e.preventDefault(); cardGo(ca); return; }
    var q = x.closest('[data-qty][data-key]'); if (q) { changeLine(q.dataset.key, +q.dataset.qty); return; }
    var add = x.closest('[data-add]'); if (add) { addToCart([{ id: +add.dataset.add, quantity: 1 }], add); return; }
    var om = x.closest('[data-open-modal]'); if (om) { var m = document.getElementById(om.dataset.openModal); if (m) { m.hidden = false; m._from = om; modalOpen = m; document.body.classList.add('lock'); var c = m.querySelector('[data-close-modal]'); if (c) c.focus(); } return; }
    if (x.closest('[data-close-modal]') || (modalOpen && x === modalOpen)) { closeModal(); return; }
    if (x.closest('[data-close]')) { close(); return; }
    if (!x.closest('.nav')) closeMega();
  });

  /* ---------- Start ---------- */
  function init() {
    initHeader(); initSearch(); initTabs(document); initFacets(); initRecs(); applyView(getView());
    $$('[data-product]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Temaredigeraren: initiera om sektioner när de ändras
  document.addEventListener('shopify:section:load', function (e) {
    initTabs(e.target); $$('[data-product]', e.target).forEach(initProduct); initRecs();
    if (e.target.querySelector('#hdr')) initHeader();
  });
  document.addEventListener('shopify:block:select', function (e) { var li = e.target.closest && e.target.closest('.nav li'); if (li) setMega(li); });
})();
